"use strict";

const { isArray } = require("./arrays");

/**
 * Checks if the value is an object type.
 * @param {*} value
 * @returns {boolean}
 */
function isObject(value) {
  return (
    value !== null &&
    value !== undefined &&
    (value === Object(value) ||
      typeof val === "function" ||
      typeof val === "object")
  );
}

/**
 * Checks if the value is empty. Can be used with most JavaScript types.
 * Empty is defined in this context by not having any value or properties defined.
 * @param {*} value
 * @returns {boolean}
 */
function isNullOrEmpty(value) {
  return (
    !value ||
    (isArray(value) && !value.length) ||
    (isObject(value) && Object.entries(value).length === 0)
  );
}

/**
 * Parses the value with the key as a location into the object/array.
 * This is an alternative to Lodash get and behaves similarly.
 * @param {object | array} value
 * @param {string | array} keys
 * @param {*} defaultVal
 * @returns {*}
 */
function getProp(value, keys, defaultVal = undefined) {
  if (!isNullOrEmpty(value)) {
    keys = Array.isArray(keys) ? keys : keys.split(".");
    value = value[keys[0]];
    if (value && keys.length > 1) {
      return getProp(value, keys.slice(1), defaultVal);
    }
  }
  return value ? value : defaultVal;
}

module.exports = {
  isObject,
  isNullOrEmpty,
  getProp
};
